import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import MobileHeader from '../Layout/Header/DemoHeader/DemoHeaderMobile';
import AdminSidebar from './AdminSidebar';

export default function AdminLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="h-screen overflow-hidden bg-[#0a0118] text-white">
      {/* Mobile Header (reusing from main site) */}
      <MobileHeader />

      {/* Desktop Header */}
      <div className="relative z-50">
        <AdminHeader />
      </div>

      <div className="flex pt-[80px] h-full"> {/* Offset for header and full height */}
        {/* Sidebar */}
        <AdminSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col min-w-0">
          {/* Content - ONLY scrollable area */}
          <main className="flex-1 p-6 overflow-auto custom-scrollbar">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}

